import { render, staticRenderFns } from "./ChangeEmail1.vue?vue&type=template&id=4b2de8d8&scoped=true"
import script from "./ChangeEmail1.vue?vue&type=script&lang=js"
export * from "./ChangeEmail1.vue?vue&type=script&lang=js"
import style0 from "./ChangeEmail1.vue?vue&type=style&index=0&id=4b2de8d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2de8d8",
  null
  
)

export default component.exports